import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { textureOptions, colorOptions } from './constants'
import Select from 'react-select'
import Switch from 'react-switch'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotNumericDecimal } from 'context/Utilities'

const WGCornmealPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    Texture: item.Texture,
    Color: item.Color,
    Size: item.Size,
    WholeGrainCert: item.WholeGrainCert,
  })

  const methods = useFormContext()
  const {
    onChangeReviewer,
    setSelectReviewer,
    setSwitchReviewer,
    asterisk,
  } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      const {
        category,
        subCategory,
        Texture,
        Color,
        Size,
        WholeGrainCert,
      } = item
      setPackaging({
        category,
        subCategory,
        Texture,
        Color,
        Size,
        WholeGrainCert,
      })
    }
    // eslint-disable-next-line
  }, [item])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <h6>Texture {asterisk}</h6>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={textureOptions}
            name="Texture"
            placeholder="Select Texture"
            defaultValue={{
              label: packaging.Texture,
              value: packaging.Texture,
            }}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              return selected
            }}
            control={methods.control}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Texture"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
        <FormGroup>
          <h6>Size {asterisk}</h6>
          <Controller
            as={Input}
            name="Size"
            placeholder={'12 - 48 ounces'}
            defaultValue={packaging.Size}
            control={methods.control}
            rules={{
              validate: Size => Size >= 12 && Size <= 48,
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
            }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Size"
              message={'⚠ Size must be between 12 - 48 ounces.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={6}>
        <FormGroup>
          <h6>Color {asterisk}</h6>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={colorOptions}
            name="Color"
            placeholder="Select Color"
            defaultValue={{
              label: packaging.Color,
              value: packaging.Color,
            }}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              return selected
            }}
            control={methods.control}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Color"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
        <FormGroup>
          <p>
            <strong>
              I certify that whole grain corn is the first and only ingredient
              in this product. {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="WholeGrainCert"
            id="WholeGrainCert"
            control={methods.control}
            defaultValue={item.WholeGrainCert}
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              return checked
            }}
            rules={{
              validate: WholeGrainCert => WholeGrainCert === true,
            }}
            disabled={isDisabled}
          />
          <br />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="WholeGrainCert"
              message={
                '⚠ You must certify that whole grain corn is the first and only ingredient in this product.'
              }
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

WGCornmealPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default WGCornmealPackageReview
